import React from "react";
import MyContext from "../../context/MyContext";
import {
  CrossIcon as HamburgerMenuClose,
  HamburgerMenu
} from "../../assets/img/icons";

const MobileHamburgerMenu = props => (
  <MyContext.Consumer>
    {context => (
      <>
        <button
          className={`hamburger-btn btn btn-plain mt-1`}
          onClick={() => context.updateMenuToggled()}
          style={{ color: `${props.headerTextColor}` }}
        >
          {!context.menuToggled && <HamburgerMenu />}
          {context.menuToggled && <HamburgerMenuClose />}
        </button>
      </>
    )}
  </MyContext.Consumer>
);

export default MobileHamburgerMenu;
